import { dateDayWeeksBefore } from 'utils/dates';

const strategyExecution = [
  //   { investor: 'I', date: dateDayWeeksBefore(5, 5), strategyExecution: 1 },
  //   { investor: 'J', date: dateDayWeeksBefore(5, 5), strategyExecution: 2 },
  //   { investor: 'L', date: dateDayWeeksBefore(5, 5), strategyExecution: 8 },
  //   { investor: 'M', date: dateDayWeeksBefore(5, 5), strategyExecution: 6 },
  //   { investor: 'N', date: dateDayWeeksBefore(4, 1), strategyExecution: 6 },
  //   { investor: 'O', date: dateDayWeeksBefore(4, 1), strategyExecution: 9 },
  //   { investor: 'P', date: dateDayWeeksBefore(4, 1), strategyExecution: 10 },
  //   { investor: 'Q', date: dateDayWeeksBefore(4, 5), strategyExecution: 3 },
  //   { investor: 'R', date: dateDayWeeksBefore(4, 5), strategyExecution: 6 },
  //   { investor: 'S', date: dateDayWeeksBefore(4, 5), strategyExecution: 4 },
  //   { investor: 'T', date: dateDayWeeksBefore(3, 1), strategyExecution: 8 },
  //   { investor: 'U', date: dateDayWeeksBefore(3, 1), strategyExecution: 3 },
  //   { investor: 'A', date: dateDayWeeksBefore(3, 2), strategyExecution: 6 },
  //   { investor: 'B', date: dateDayWeeksBefore(3, 2), strategyExecution: 10 },
  //   { investor: 'C', date: dateDayWeeksBefore(3, 2), strategyExecution: 8 },
  //   { investor: 'D', date: dateDayWeeksBefore(3, 2), strategyExecution: 3 },
  //   { investor: 'E', date: dateDayWeeksBefore(3, 5), strategyExecution: 4 },
  //   { investor: 'F', date: dateDayWeeksBefore(3, 5), strategyExecution: 7 },
  //   { investor: 'G', date: dateDayWeeksBefore(3, 5), strategyExecution: 3 },
  //   { investor: 'AA', date: dateDayWeeksBefore(3, 5), strategyExecution: 3 },
  //   { investor: 'BB', date: dateDayWeeksBefore(2, 2), strategyExecution: 6 },
  //   { investor: 'BA', date: dateDayWeeksBefore(2, 2), strategyExecution: 4 },
  //   { investor: 'BC', date: dateDayWeeksBefore(2, 2), strategyExecution: 8 },
  //   { investor: 'CD', date: dateDayWeeksBefore(2, 3), strategyExecution: 3 },
  //   { investor: 'EF', date: dateDayWeeksBefore(2, 3), strategyExecution: 6 },
  //   { investor: 'FG', date: dateDayWeeksBefore(2, 3), strategyExecution: 10 },
  //   { investor: 'FD', date: dateDayWeeksBefore(2, 5), strategyExecution: 8 },
  //   { investor: 'XD', date: dateDayWeeksBefore(2, 5), strategyExecution: 3 },
  //   { investor: 'EF', date: dateDayWeeksBefore(1, 3), strategyExecution: 4 },
  //   { investor: 'FV', date: dateDayWeeksBefore(1, 4), strategyExecution: 7 },
  //   { investor: 'GN', date:  dateDayWeeksBefore(1, 5), strategyExecution: 3 },
  //   { investor: 'ZCX', date: dateDayWeeksBefore(0, 0), strategyExecution: 3 }

  // ];

  /// / set 1

  { investor: 'I', date: dateDayWeeksBefore(5, 5), strategyExecution: 7 },
  { investor: 'J', date: dateDayWeeksBefore(5, 5), strategyExecution: 6 },
  { investor: 'L', date: dateDayWeeksBefore(5, 5), strategyExecution: 5 },
  { investor: 'M', date: dateDayWeeksBefore(5, 5), strategyExecution: 8 },
  { investor: 'N', date: dateDayWeeksBefore(4, 1), strategyExecution: 7 },
  { investor: 'O', date: dateDayWeeksBefore(4, 1), strategyExecution: 5 },
  { investor: 'P', date: dateDayWeeksBefore(4, 1), strategyExecution: 6 },
  { investor: 'Q', date: dateDayWeeksBefore(4, 5), strategyExecution: 7 },
  { investor: 'R', date: dateDayWeeksBefore(4, 5), strategyExecution: 4 },
  { investor: 'S', date: dateDayWeeksBefore(4, 5), strategyExecution: 6 },
  { investor: 'T', date: dateDayWeeksBefore(3, 1), strategyExecution: 7 },
  { investor: 'U', date: dateDayWeeksBefore(3, 1), strategyExecution: 4 },
  { investor: 'A', date: dateDayWeeksBefore(3, 2), strategyExecution: 4 },
  { investor: 'B', date: dateDayWeeksBefore(3, 2), strategyExecution: 6 },
  { investor: 'C', date: dateDayWeeksBefore(3, 2), strategyExecution: 6 },
  { investor: 'D', date: dateDayWeeksBefore(3, 2), strategyExecution: 7 },
  { investor: 'E', date: dateDayWeeksBefore(3, 5), strategyExecution: 8 },
  { investor: 'F', date: dateDayWeeksBefore(3, 5), strategyExecution: 7 },
  { investor: 'G', date: dateDayWeeksBefore(3, 5), strategyExecution: 8 },
  { investor: 'AA', date: dateDayWeeksBefore(3, 5), strategyExecution: 8 },
  { investor: 'BB', date: dateDayWeeksBefore(2, 2), strategyExecution: 7 },
  { investor: 'BA', date: dateDayWeeksBefore(2, 2), strategyExecution: 8 },
  { investor: 'BC', date: dateDayWeeksBefore(2, 2), strategyExecution: 8 },
  { investor: 'CD', date: dateDayWeeksBefore(2, 3), strategyExecution: 7 },
  { investor: 'EF', date: dateDayWeeksBefore(2, 3), strategyExecution: 8 },
  { investor: 'FG', date: dateDayWeeksBefore(2, 3), strategyExecution: 7 },
  { investor: 'FD', date: dateDayWeeksBefore(2, 5), strategyExecution: 9 },
  { investor: 'XD', date: dateDayWeeksBefore(2, 5), strategyExecution: 6 },
  { investor: 'EF', date: dateDayWeeksBefore(1, 3), strategyExecution: 4 },
  { investor: 'FV', date: dateDayWeeksBefore(1, 4), strategyExecution: 8 },
  { investor: 'GN', date: dateDayWeeksBefore(1, 5), strategyExecution: 6 },
  { investor: 'ZCX', date: dateDayWeeksBefore(0, 0), strategyExecution: 7 }
];

export default strategyExecution;
